import React from 'react';
import Editor from '@monaco-editor/react';

const JsonEditor = ({ value, onChange, height = 360, readOnly = false }) => {
  const handleMount = (editor, monaco) => {
    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
      validate: true,
      allowComments: false,
      schemas: [],
      enableSchemaRequest: false,
    });
    editor.updateOptions({ tabSize: 2, insertSpaces: true });
  };

  return (
    <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, overflow: 'hidden' }}>
      <Editor
        height={typeof height === 'number' ? `${height}px` : height}
        defaultLanguage="json"
        language="json"
        value={value}
        onChange={(v) => onChange(v ?? '')}
        onMount={handleMount}
        options={{
          minimap: { enabled: false },
          fontSize: 13,
          fontFamily:
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
          lineNumbers: 'on',
          glyphMargin: false,
          folding: true,
          lineDecorationsWidth: 6,
          lineNumbersMinChars: 3,
          renderLineHighlight: 'line',
          scrollBeyondLastLine: false,
          automaticLayout: true,
          formatOnPaste: true,
          formatOnType: true,
          wordWrap: 'on',
          smoothScrolling: true,
          scrollbar: {
            verticalScrollbarSize: 8,
            horizontalScrollbarSize: 8,
          },
          readOnly,
          padding: { top: 8, bottom: 8 },
        }}
        theme="vs"
      />
    </div>
  );
};

export default JsonEditor;
